import { AlignmentType, BorderStyle, Paragraph, Table, TableCell, TableRow, TextRun, WidthType, ShadingType } from "docx";


export const page2Heading = new Paragraph({
    spacing: { before: 300, after: 400 },
    alignment: AlignmentType.CENTER,
    children: [
        new TextRun({
            text: "Document Control",
            color: "2D72B5",
            font: "Arial",
            size: 40,
            bold: true,
            italics: false,
        })
    ]
})


export function documentPreparation(dateString, certInApplicationName) {
    const date = new Date(dateString);

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        else {
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const formattedDate = `${date.getDate()}`;
    const ordinalSuffix = getOrdinalSuffix(date.getDate());
    const formatMonth = monthNames[date.getMonth()];
    const formatYear = date.getFullYear();

    return new Table({
        width: { size: 93, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 2,
                        alignment: AlignmentType.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Document Preparation",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],

                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "FBE4D5" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Document Title",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: `Audit Report of ${certInApplicationName} Mobile Application`,
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Document ID",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                margins: { top: 100, bottom: 100, left: 100, right: 100, },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        bold: false,
                                        italics: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Document Version",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        bold: false
                                    }),
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Prepared by",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sachin Kumar S",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Reviewed by",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Manjunath NG",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Approved by",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Manjunath NG",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Released by",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Manjunath NG",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Release date",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 65, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),
                                    
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                ]
            }),
        ]
    })
}

export function documentHistory(dateString) {
    const date = new Date(dateString);

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        else {
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        }
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const formattedDate = `${date.getDate()}`;
    const ordinalSuffix = getOrdinalSuffix(date.getDate());
    const formatMonth = monthNames[date.getMonth()];
    const formatYear = date.getFullYear();

    return new Table({
        width: { size: 93, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 600 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        alignment: AlignmentType.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Document Change History",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],

                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "FBE4D5" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 25, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Version",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 50, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Date",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 50, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Remarks / Reason of change",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 25, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1.0",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 50, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),
                                   
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 50, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

        ]
    })
}

export function documentDistribution(inchargeDesignation, inchargeEmail, inchargeName, certInCustomerName) {

    return new Table({
        width: { size: 93, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 600 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 4,
                        alignment: AlignmentType.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Document Distribution List",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],

                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "FBE4D5" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 18, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Name",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 24, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Organization Name",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 21, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Designation",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Email Id",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        shading: { type: ShadingType.SOLID, color: "ACB9CA" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 18, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 26, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 24,
                                        color: '000000',
                                        italics: false,
                                        bold: false
                                    }),

                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 21, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 35, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "",
                                        font: "Arial",
                                        size: 24,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        margins: { top: 100, bottom: 100, left: 100, right: 100, },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

        ]
    })
}